// #region imports

// --- HS Code
import { AddCommand } from "./add-command";
import { RemoteCommand } from "./remote-command";
import { CommandResult } from "./command-result";
import { CommandTypes } from "./command-types";

// #endregion

export class DeleteCommand<TTarget> implements RemoteCommand {
  commandResult: CommandResult | undefined;

  get commandType(): CommandTypes {
    return CommandTypes.delete;
  }

  isExecuted: boolean;

  constructor(
    private _target: TTarget,
    public commandId: number,
    public identifier: string
  ) {
    this.isExecuted = false;
  }

  undo(): AddCommand<TTarget> {
    if (!this.isExecuted) throw new Error("Command not yet executed. Cannot undo.");
    if (!this.commandResult?.isSuccessful) throw new Error('Command did not complete successfully. Cannot undo.')

    return new AddCommand(this._target, this.commandId, this.identifier);
  }

  createCommandDto(): any {
    return {
      commandId: this.commandId,
      identifier: this.identifier,
      commandType: this.commandType,
      target: this._target
    }
  }
}
